
import { Options, Vue } from 'vue-class-component';
import router from '@/router';

@Options({
  data() {
    return {
      count: 0,
      timeRef: 0
    }
  },
  mounted() {
    this.timeRef = setInterval(() => this.count = this.count + 1, 1000)
  },
  unmounted() {
    clearInterval(this.timeRef)
  },
  methods: {
    forward() {
      router.push('/p2')
    },
    back() {
      router.go(-1)
    }
  }
})
export default class HomeView extends Vue { }
